/* eslint-disable no-unused-vars */
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Routes from './Routes';
import { StructuredData, GoogleAnalytics } from './components/SEO';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'aos/dist/aos.css';

const App = () => {
    return (
        <BrowserRouter>
            <StructuredData />
            <GoogleAnalytics />
            <Routes />
        </BrowserRouter>
    );
};

export default App;
